// @flow
import { fetchPatientData } from './patientActions';
import { SERVER_ADDRESS, fetchPost } from '../util/actionsUtil';

export const DELETE_TREATMENT_LOADING = 'DELETE_TREATMENT_LOADING';
export const DELETE_TREATMENT_SUCCESS = 'DELETE_TREATMENT_SUCCESS';
export const DELETE_TREATMENT_ERROR = 'DELETE_TREATMENT_ERROR';

function deleteTreatment(patientId: string, treatmentId: string, type: string) {
  return ((dispatch: Function) => {
    fetchPost(
      `${SERVER_ADDRESS}/treatment/delete${type}`,
      {
        treatmentId,
        patientId,
      },
      (data) => {
        dispatch({
          type: DELETE_TREATMENT_SUCCESS,
          data,
        });
        dispatch(fetchPatientData(patientId));
      },
      (error) => {
        dispatch({
          type: DELETE_TREATMENT_ERROR,
          error: error.toString(),
        });
      },
    );
    dispatch({
      type: DELETE_TREATMENT_LOADING,
    });
  });
}

export function deleteAcuteMedication(patientId: string, treatmentId: string) {
  return deleteTreatment(patientId, treatmentId, 'AcuteMedication');
}
export function deleteChronicMedication(patientId: string, treatmentId: string) {
  return deleteTreatment(patientId, treatmentId, 'ChronicMedication');
}
export function deleteAcuteIntervention(patientId: string, treatmentId: string) {
  return deleteTreatment(patientId, treatmentId, 'AcuteIntervention');
}
export function deleteChronicIntervention(patientId: string, treatmentId: string) {
  return deleteTreatment(patientId, treatmentId, 'ChronicIntervention');
}

export const ADD_TREATMENT_LOADING = 'ADD_TREATMENT_LOADING';
export const ADD_TREATMENT_SUCCESS = 'ADD_TREATMENT_SUCCESS';
export const ADD_TREATMENT_ERROR = 'ADD_TREATMENT_ERROR';

function addTreatment(patientId: string, treatment: Object, type: string) {
  return ((dispatch: Function) => {
    fetchPost(
      `${SERVER_ADDRESS}/treatment/add${type}`,
      {
        ...treatment,
        patientId,
      },
      (data) => {
        dispatch({
          type: ADD_TREATMENT_SUCCESS,
          data,
        });
        dispatch(fetchPatientData(patientId));
      },
      (error) => {
        dispatch({
          type: ADD_TREATMENT_ERROR,
          error: error.toString(),
        });
      },
    );
    dispatch({
      type: ADD_TREATMENT_LOADING,
    });
  });
}

export function addAcuteMedication(patientId: string, treatment: Object) {
  return addTreatment(patientId, treatment, 'AcuteMedication');
}
export function addChronicMedication(patientId: string, treatment: Object) {
  return addTreatment(patientId, treatment, 'ChronicMedication');
}
export function addAcuteIntervention(patientId: string, treatment: Object) {
  return addTreatment(patientId, treatment, 'AcuteIntervention');
}
export function addChronicIntervention(patientId: string, treatment: Object) {
  return addTreatment(patientId, treatment, 'ChronicIntervention');
}

export const UPDATE_TREATMENT_LOADING = 'UPDATE_TREATMENT_LOADING';
export const UPDATE_TREATMENT_SUCCESS = 'UPDATE_TREATMENT_SUCCESS';
export const UPDATE_TREATMENT_ERROR = 'UPDATE_TREATMENT_ERROR';

function updateTreatment(patientId: string, treatment: Object, type: string) {
  return ((dispatch: Function) => {
    fetchPost(
      `${SERVER_ADDRESS}/treatment/update${type}`,
      {
        ...treatment,
        patientId,
      },
      (data) => {
        dispatch({
          type: UPDATE_TREATMENT_SUCCESS,
          data,
        });
        dispatch(fetchPatientData(patientId));
      },
      (error) => {
        dispatch({
          type: UPDATE_TREATMENT_ERROR,
          error: error.toString(),
        });
      },
    );
    dispatch({
      type: UPDATE_TREATMENT_LOADING,
    });
  });
}

export function updateAcuteMedication(patientId: string, treatment: Object) {
  return updateTreatment(patientId, treatment, 'AcuteMedication');
}
export function updateChronicMedication(patientId: string, treatment: Object) {
  return updateTreatment(patientId, treatment, 'ChronicMedication');
}
export function updateAcuteIntervention(patientId: string, treatment: Object) {
  return updateTreatment(patientId, treatment, 'AcuteIntervention');
}
export function updateChronicIntervention(patientId: string, treatment: Object) {
  return updateTreatment(patientId, treatment, 'ChronicIntervention');
}

export function deleteAllergy(patientId: string, allergyId: string) {
  return ((dispatch: Function) => {
    fetchPost(
      `${SERVER_ADDRESS}/treatment/deleteAllergy`,
      {
        allergyId,
        patientId,
      },
      (data) => {
        dispatch({
          type: DELETE_TREATMENT_SUCCESS,
          data,
        });
        dispatch(fetchPatientData(patientId));
      },
      (error) => {
        dispatch({
          type: DELETE_TREATMENT_ERROR,
          error: error.toString(),
        });
      },
    );
    dispatch({
      type: DELETE_TREATMENT_LOADING,
    });
  });
}

export function addAllergy(patientId: string, allergy: Object) {
  return ((dispatch: Function) => {
    fetchPost(
      `${SERVER_ADDRESS}/treatment/addAllergy`,
      {
        ...allergy,
        patientId,
      },
      (data) => {
        dispatch({
          type: ADD_TREATMENT_SUCCESS,
          data,
        });
        dispatch(fetchPatientData(patientId));
      },
      (error) => {
        dispatch({
          type: ADD_TREATMENT_ERROR,
          error: error.toString(),
        });
      },
    );
    dispatch({
      type: ADD_TREATMENT_LOADING,
    });
  });
}

export function updateAllergy(patientId: string, allergy: Object) {
  return ((dispatch: Function) => {
    fetchPost(
      `${SERVER_ADDRESS}/treatment/updateAllergy`,
      {
        ...allergy,
        patientId,
      },
      (data) => {
        dispatch({
          type: UPDATE_TREATMENT_SUCCESS,
          data,
        });
        dispatch(fetchPatientData(patientId));
      },
      (error) => {
        dispatch({
          type: UPDATE_TREATMENT_ERROR,
          error: error.toString(),
        });
      },
    );
    dispatch({
      type: UPDATE_TREATMENT_LOADING,
    });
  });
}



// WEBPACK FOOTER //
// ./client/src/actions/treatmentActions.js